import { ArrayUtil } from "@shared/utility.js";

export class Rect {
    
    static fromArray(a) {
        return new Rect(a[0], a[1], a[2], a[3]);
    }
    
    constructor(x, y, width, height) {
        if (width < 0 || height < 0) {
            throw new Error("Width and height must be non-negative.");
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    get maxX() {
        return this.x + this.width;
    }
    
    get maxY() {
        return this.y + this.height;
    }
    
    aspectRatio() {
        return this.width / this.height;
    }
    
    intersectsWithRect(otherRect) {
        return (
            this.x < otherRect.maxX &&
            this.maxX > otherRect.x &&
            this.y < otherRect.maxY &&
            this.maxY > otherRect.y
        );
    }
    
    insetBy(insets) {
        this.x += ArrayUtil.left(insets);
        this.width -= ArrayUtil.left(insets) + ArrayUtil.right(insets);
        this.y += ArrayUtil.top(insets);
        this.height -= ArrayUtil.top(insets) + ArrayUtil.bottom(insets);
    }

    rectInsetBy(insets) {
        var newRect = new Rect(this.x, this.y, this.width, this.height);
        newRect.insetBy(insets);
        return newRect;
    }
    
    // A little different than insetBy(); this adjusts x and y but not width or height
    insetOriginBy(insets) {
        this.y += ArrayUtil.top(insets) - ArrayUtil.bottom(insets);
        this.x += ArrayUtil.left(insets) - ArrayUtil.right(insets);
    }
    
    debugDesc() {
        return `(${this.x}, ${this.y}, ${this.width}, ${this.height})`;
    }
}